import { MapPin } from "lucide-react";
import { placeOf, stepLabel, when } from "@/lib/shipments";

// Histórico da entrega, do mais recente para o mais antigo.
export const TrackTimeline = ({ events }) => {
  const list = [...(Array.isArray(events) ? events : [])].reverse();
  if (!list.length) return null;
  return (
    <ol data-testid="track-timeline" className="relative space-y-6 border-l border-white/15 pl-6">
      {list.map((ev, i) => (
        <li key={`${ev.at}-${i}`} data-testid={`track-event-${i}`} className="relative">
          <span className={`absolute -left-[31px] top-1 h-3.5 w-3.5 rounded-full border-2 ${i === 0 ? "border-white bg-white" : "border-white/40 bg-[#09090b]"}`} />
          <p className="text-xs text-zinc-400">{when(ev.at)}</p>
          <p className="mt-0.5 font-semibold text-white">{stepLabel(ev.step)}</p>
          {placeOf(ev) && <p className="mt-1 flex items-center gap-1.5 text-sm text-zinc-300"><MapPin className="h-3.5 w-3.5 shrink-0" />{placeOf(ev)}</p>}
          {ev.note && <p className="mt-1 text-sm text-zinc-300">{ev.note}</p>}
        </li>
      ))}
    </ol>
  );
};
